import { getEnvironment, getMarketingAttributionParams } from 'Lib/AppUtils'

type AppEnvironment = ReturnType<typeof getEnvironment>

// Keep in sync with the same map in the RN app (`src/Config/InAppConfig.js`) — the
const HEALTH_COURSE_URLS: Record<AppEnvironment, string> = {
  production: 'https://kurs.bodyfast.app',
  staging: 'https://health-course-onboarding-bf-staging.web.app',
  development: 'https://health-course-onboarding-bf-dev.web.app'
}

export const canShowHealthCourseAlternative = (
  enabled: boolean,
  countryCode?: string | null
): boolean =>
  enabled && countryCode?.toUpperCase() === 'DE'

export const getHealthCourseOnboardingUrl = (environment: AppEnvironment = getEnvironment()): string =>
  HEALTH_COURSE_URLS[environment]

export const HEALTH_COURSE_UPSELL_LANDING_VERSION = '2'

/**
 * Builds the onboarding URL for the upsell block: the marketing landing variant,
 * plus the onboarding token so the purchase attaches to the account the buyer
 * came from.
 */
export const buildHealthCourseOnboardingUrl = (
  onboardingToken?: string | null,
  environment: AppEnvironment = getEnvironment()
): string => {
  const params = new URLSearchParams({ version: HEALTH_COURSE_UPSELL_LANDING_VERSION })
  if (onboardingToken) params.set('token', onboardingToken)

  getMarketingAttributionParams().forEach((value, key) => { params.set(key, value) })

  return `${getHealthCourseOnboardingUrl(environment)}?${params.toString()}`
}
